<template>
  <CodeColorIndicator
    v-if="feedsCodes.length || isCompact"
    :codeIds="feedsCodes"
    :allCodeItems="allCodeItems"
    :allCodeItemsByUid="allCodeItemsByUid"
    :codeColors="codeColors"
    :maxItems="feedMaxItems"
    :isCompact="isCompact"
    codeType="feeds"
    data-test-selector="code-indicator-line"
  />
  <CodeColorIndicator
    v-if="nonFeedsCodes.length || isCompact"
    :codeIds="nonFeedsCodes"
    :allCodeItems="allCodeItems"
    :allCodeItemsByUid="allCodeItemsByUid"
    :codeColors="codeColors"
    :maxItems="nonFeedMaxItems"
    :isCompact="isCompact"
    codeType="non-feeds"
    data-test-selector="code-indicator-circle"
  />
</template>

<script setup lang="ts">
/* TODO: Удалить строки с игнорированием TS в задаче PUB-4328 (Оптимизация обработки кодов) */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { computed } from 'vue'
import CodeColorIndicator from './CodeColorIndicator.vue'
import type { TCodeId } from '@/ContextTab/stores/types'


const props = withDefaults(
  defineProps<{
    codeIds?: TCodeId[]
    allCodeItems?: object
    allCodeItemsByUid?: object
    codeColors?: object
    codeType?: 'pubs' | 'non-pubs'
    newsId?: number | string | undefined
    codesFilter?: (code: any) => boolean
    isCompact?: boolean
    feedMaxItems?: number
    nonFeedMaxItems?: number
  }>(),
  {
    codeIds: () => [],
    allCodeItems: () => ({}),
    allCodeItemsByUid: () => ({}),
    codeColors: () => ({}),
    codeType: 'pubs',
    newsId: undefined,
    codesFilter: () => true,
    isCompact: false,
    feedMaxItems: 4,
    nonFeedMaxItems: 3,
  },
)
const feedsCodes = computed(() =>
  props.codeIds.filter((id) => props.codesFilter({ id })),
)
const nonFeedsCodes = computed(() =>
  props.codeIds.filter((id) => !props.codesFilter({ id })),
)
</script>

<style scoped></style>
